import * as React from "react";
import "./styles.scss";
import {
	ProcessStage,
	ProcessStageArrow,
	ProcessStageArrowDirection,
	ProcessStageOrder,
	useProcessController,
} from "../../../../Processes";
import {Display} from "../../../../../components/Display";
import {motion, MotionProps} from "framer-motion";
import {VeboxOverlayController} from "../../../../../components/overlay/VeboxOverlay";
import {DefineEquipmentPage} from "../DefineEquipmentPage";
import {CensusElaboration} from "../../widgets/CensusElaboration";
import {DefineEquipmentPageProviderContext, PAGES,} from "../../providers/DefineEquipmentPageProvider";

interface DefineEquipmentProps {
    stepNumber: number;
    stageOrder: ProcessStageOrder;
    title: string;
    divProps: MotionProps;
    overlayController: VeboxOverlayController;
}

export const DefineAndProcessEquipmentStep: React.FC<DefineEquipmentProps> = ({
                                                                                  stepNumber,
                                                                                  title,
                                                                                  stageOrder,
                                                                                  divProps,
                                                                                  overlayController,
                                                                              }) => {
    const {currentPage, totalCount} = React.useContext(
        DefineEquipmentPageProviderContext,
    );
    const processController = useProcessController();
    return (
        <Display isVisible={processController.position + 1 === stepNumber}>
            <motion.div key={stepNumber} {...divProps}>
                <ProcessStage
                    stepNumber={stepNumber}
                    title={title}
                    stageOrder={stageOrder}
                    bodyStyles={{alignItems: "initial"}}
                >
                    <div className={"flx-row"}>
                        <ProcessStageArrow
                            stepNumber={stepNumber}
                            direction={ProcessStageArrowDirection.BACKWARD}
                            visible={false}
                        />
                        <Display isVisible={PAGES.DEFINE_EQUIPMENT === currentPage}>
                            <DefineEquipmentPage overlayController={overlayController}/>
                        </Display>
                        <Display isVisible={PAGES.ELABORATION === currentPage}>
                            <CensusElaboration totalEquipment={totalCount}/>
                        </Display>
                        <ProcessStageArrow
                            stepNumber={stepNumber}
                            direction={ProcessStageArrowDirection.FORWARD}
                            visible={false}
                        />
                    </div>
                </ProcessStage>
            </motion.div>
        </Display>
    );
};
